module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Landing-page-w540.dfc6004f.jpg";